import { render, staticRenderFns } from "./module7.vue?vue&type=template&id=2048cd38&scoped=true"
import script from "./module7.vue?vue&type=script&lang=js"
export * from "./module7.vue?vue&type=script&lang=js"
import style0 from "./module7.vue?vue&type=style&index=0&id=2048cd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2048cd38",
  null
  
)

export default component.exports